import api from "@/services/api";

const state = {
  summary: null,
  itcSummary: null,
  gstr3b: null,
};

const mutations = {
  SET_GST_SUMMARY(state, data) {
    state.summary = data;
  },
  SET_ITC_SUMMARY(state, data) {
    state.itcSummary = data;
  },
  SET_GSTR3B(state, data) {
    state.gstr3b = data;
  },
};

const actions = {
  async getGstSummary({ commit }, params = {}) {
    try {
      const res = await api.get("/gst-reports/summary", { params });
      commit("SET_GST_SUMMARY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching GST report:", error.message);
      throw error;
    }
  },

  async getItcSummary({ commit }, params = {}) {
    try {
      const res = await api.get("/itc-summary/summary", { params });
      commit("SET_ITC_SUMMARY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching ITC summary:", error.message);
      throw error;
    }
  },

  async getGstr3bSummary({ commit }, params = {}) {
    try {
      const res = await api.get("/gst-reports/gstr3b", { params });
      commit("SET_GSTR3B", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching GSTR-3B summary:", error.message);
      throw error;
    }
  },

  async downloadInvoicesZip(_, params = {}) {
    try {
      const res = await api.get("/gst-reports/download-invoices", {
        params,
        responseType: "blob",
      });
      return res;
    } catch (error) {
      console.error("Error downloading invoices zip:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
